import { Anchor, Avatar, Box, Card, CardBody, Text } from 'grommet';
import { Folder, Github, Group, Notes } from 'grommet-icons';
import React from 'react';

interface IProps {
  name: string;
  url: string;
  avatarUrl: string;
  followers: number;
  gists: number;
  repos: number;
}

const UserProfile = ({
  name,
  avatarUrl,
  url,
  followers,
  gists,
  repos,
}: IProps) => {
  const onClick = () => window.open(url, '_blank');
  return (
    <Box pad="large" align="center">
      <Card elevation="large" width="medium" onClick={onClick}>
        <CardBody pad="small">
          <Box gap="small" align="center" direction="row" pad="small">
            <Avatar size="xlarge" src={avatarUrl} />
            <Box>
              <Text weight="bold"> {name} </Text>
            </Box>
            <Box>
              <Anchor href={url} target="_blank" rel="noopener">
                <Github size="medium" />
              </Anchor>
            </Box>
          </Box>
          <Box gap="xlarge" align="center" direction="row" pad="small">
            <Box align="center">
              <Group size="medium" />
              <Text weight="bold"> {followers} </Text>
            </Box>
            <Box align="center">
              <Notes size="medium" /> <Text weight="bold"> {gists} </Text>
            </Box>
            <Box align="center">
              <Folder size="medium" /> <Text weight="bold"> {repos} </Text>
            </Box>
          </Box>
        </CardBody>
      </Card>
    </Box>
  );
};

export { UserProfile };
